import { render, staticRenderFns } from "./SupplierContacts.vue?vue&type=template&id=2633d970&"
import script from "./SupplierContacts.vue?vue&type=script&lang=js&"
export * from "./SupplierContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports